/**
 * @param {string} eventName
 * @param {string} query
 * @param {Element} delegate
 * @param {Function} cb
 */
export default (eventName, query, delegate, cb) => {
  delegate.addEventListener(eventName, (...params) => {
    if (params[0].target.matches(query)) {
      cb(...params);
    }
  });
};
